<template>
  <v-row class="ma-0" :id="data.id">
    <v-col cols="12" class="detail-cards">
      <div v-if="initialLoading">
        <contentLoader
          :height="70"
          :width="400"
          :speed="2"
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="0" y="0" rx="2" ry="2" width="394.46" height="17.93" />
          <rect x="0" y="25" rx="2" ry="2" width="394.46" height="17.93" />
          <rect x="0" y="50" rx="2" ry="2" width="394.46" height="17.93" />
          <!-- <rect x="0" y="75" rx="2" ry="2" width="394.46" height="17.93" />
          <rect x="0" y="100" rx="2" ry="2" width="394.46" height="17.93" />
          <rect x="0" y="125" rx="2" ry="2" width="394.46" height="17.93" />
          <rect x="0" y="150" rx="2" ry="2" width="394.46" height="17.93" /> -->
        </contentLoader>
      </div>
      <div v-if="!initialLoading" class="root-QkPFX">
        <div class="container-OWvmz">
          <div class="left-26Ldc">
            <div class="iconContainer-2MeWz">
              <div class="icon-3NJqh">
                <!-- <img src="https://cdn-app.peakon.com/apps/9c69b2106e8e4591cdaf2e0c3d83c9f9.svg"> -->
                <v-icon>{{data.icon}}</v-icon>
              </div>
            </div>
            <div>
              <div class="headline-30cHB"><span>{{data.title}}</span></div>
              <div class="range-1KVMZ">
                <div class="root-1NH1W">
                    <div v-html="data.sub"></div>
                </div>
              </div>
              <div class="summary-3WdmL"><span>{{data.desc}}</span></div>
              <div>
                <v-btn
                  color="primary"
                  class="btn btn-primary btn-small"
                  tabindex="0"
                  outlined
                  aria-disabled="false"
                  @click="onView(data.id)"
                  :disabled="data.id === 'separation'"
                >
                  View report
                </v-btn>
              </div>
            </div>
          </div>
          <div class="right-3NnIh">
            <div class="rightTop-MkCrM">
              <div class="benchmark-2aQ2U">
                <div class="rightHeader-1gKU_">
                  <div class="rightHeaderIcon-D4hI9">
                    <svg width="24" height="24">
                      <path
                        d="M11.164 8.224l-1.73 3.024a.5.5 0 11-.868-.496l2.002-3.5a.5.5 0 01.721-.162l4.57 3.2 3.22-5.058a.5.5 0 11.843.536l-3.5 5.5a.5.5 0 01-.709.142l-4.549-3.186zm-5.73 10.524a.5.5 0 11-.868-.496l2-3.5a.5.5 0 11.868.496l-2 3.5zM7.34 13H4.5a.5.5 0 010-1h3a.5.5 0 01.29.093l6.656 4.754 4.7-4.7a.5.5 0 01.708.707l-5 5a.5.5 0 01-.645.053L7.34 13z"
                        fill="#111"
                      ></path>
                    </svg>
                  </div>
                  <div class="rightHeaderText-3QAP5">Avg. engagement</div>
                </div>
                <div class="rightContent-1quOS">
                  <div class="root-1ZrjO small-1dQfH positive-1JNyI">
                    <div class="score-3eag5">
                      <div class="root-kZ8J_ static-24kmv" style="font-size: 27px;">
                        <span class="score-2Z_IE" style="font-size: 27px;">
                          {{Number.parseFloat(data.average).toFixed(1)}}/5
                        </span>
                      </div>
                    </div>
                    <div class="container-A8OY-">
                    <!-- <div class="label-2HCys"><strong>0.1</strong> above
                    </div> -->
                    <div>
                      <div class="root-2pysp small-1_LPH">
                        <div class="label-2_vVU">
                          <!-- <div>True Benchmark®</div> -->
                          <!-- <div class="badge-2Vbr1"><span class="badge-LGq1o">7.4</span>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightBottom-1e9Jt">
            <div class="rightBottomContainer-kSlaE">
              <div>
                <div class="rightHeader-1gKU_">
                  <div class="rightHeaderIcon-D4hI9">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path
                        fill="#111"
                        d="M9.5 12a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm0-1a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm7 0a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm0-1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15 18.5a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5 5.5 5.5 0 0111 0zM9.5 14a4.5 4.5 0 00-4.473 4h8.946A4.5 4.5 0 009.5 14zm9.5 1.5a2.5 2.5 0 00-3.882-2.084.5.5 0 11-.554-.832A3.5 3.5 0 0120 15.5v1a.5.5 0 01-.5.5h-3a.5.5 0 110-1H19v-.5z"
                      >
                      </path>
                    </svg>
                  </div>
                  <div class="rightHeaderText-3QAP5" style="margin-top: -4px;">
                    Disengaged employees
                  </div>
                </div>
                <div class="rightContent-1quOS"><span>{{data.disengaged}}%</span></div>
              </div>
            </div>
            <div class="rightBottomContainer-kSlaE">
              <div>
                <div class="rightHeader-1gKU_">
                  <div class="rightHeaderIcon-D4hI9">
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path
                        d="M5.5 5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4zm0-1h4A1.5 1.5 0 0111 5.5v4A1.5 1.5 0 019.5 11h-4A1.5 1.5 0 014 9.5v-4A1.5 1.5 0 015.5 4zm9 1a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4zm0-1h4A1.5 1.5 0 0120 5.5v4a1.5 1.5 0 01-1.5 1.5h-4A1.5 1.5 0 0113 9.5v-4A1.5 1.5 0 0114.5 4zm-9 10a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4zm0-1h4a1.5 1.5 0 011.5 1.5v4A1.5 1.5 0 019.5 20h-4A1.5 1.5 0 014 18.5v-4A1.5 1.5 0 015.5 13zm9 1a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4zm0-1h4a1.5 1.5 0 011.5 1.5v4a1.5 1.5 0 01-1.5 1.5h-4a1.5 1.5 0 01-1.5-1.5v-4a1.5 1.5 0 011.5-1.5z">
                      </path>
                    </svg>
                  </div>
                  <div class="rightHeaderText-3QAP5"  style="margin-top: -4px;">Participation rate</div>
                  </div>
                  <div class="rightContent-1quOS" style="">
                    <span>{{data.participants}}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col cols="12" class="analysis-cards" :id="`${data.id}-analysis`" v-if="showReport">
      <nav class="top-nav">
        <ul>
          <li
            v-for="(s,index) in sortByData"
            :key="index"
            :id="index"
          >
            <div class="top-menu"
              @click="onClickSortBy(index)"
              :class="activeSort === index ? 'top-menu--active' : ''"
            >
              <div class="top-menu__title"> {{s}} </div>
            </div>
          </li>
        </ul>
      </nav>
      <div class="nav-body">
        <v-row>
          <v-col cols="6" class="d-flex align-center" v-if="allTableData">
            <div class="mt-5 mr-4 d-flex">
              <span class="pr-1">Select</span>
              <span v-if="activeSort.replace(/_/g, ' ') === 'hrbp'">HRBP</span>
              <span v-else-if="activeSort.replace(/_/g, ' ') === 'hr manager'">HR Manager</span>
              <span v-else>&nbsp;{{activeSort.replace(/_/g, ' ')}}</span>:
            </div>
            <v-combobox
              :items="allTableData"
              multiple
              v-model="selectedHeaders"
              hide-details
            >
              <template v-slot:selection="{ index }">
                <span v-if="index === 0 && selectedHeaders">
                  {{selectedHeaders.length}}&nbsp;of&nbsp;{{allTableData.length}}&nbsp;
                  <span v-if="activeSort.replace(/_/g, ' ') === 'hrbp'">HRBP</span>
                  <span v-else-if="activeSort.replace(/_/g, ' ') === 'hr manager'">HR Manager</span>
                  <span v-else style="text-transform:capitalize">{{activeSort.replace(/_/g, ' ')}}</span>
                  &nbsp;selected
                </span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item @click="toggle()">
                  <v-list-item-action>
                    <v-icon class="ml-n1" :color="selectedHeaders.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Select all</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
          <v-col cols="4">
          </v-col>
          <v-col cols="2" class="d-flex justify-end pt-4 mt-4">
            <div class="pre-icon cursor-pointer mr-3" @click="displayPre()">
              <i class="las la-chevron-circle-left"></i>
            </div>
            <div>
              <span>{{startlimit+1}}</span>
              <span>-</span>
              <span v-if="endlimit < totalData">{{endlimit}}</span>
              <span v-else>{{selectedHeaders.length}}</span>
              <span>&nbsp;of&nbsp;</span>
              <span>&nbsp;{{allTableData.length}}&nbsp;</span>
            </div>
            <div class="next-icon cursor-pointer ml-3" @click="displayNext()">
              <i class="las la-chevron-circle-right"></i>
            </div>
          </v-col>
        </v-row>
        <div class="tableFixHead pb-7">
          <div class="table-wrap">
            <table class="table table-bordered">
              <thead v-if="allTableData">
                <tr>
                  <th class="am-table-head">
                    <div class="left-header">
                      <div class="hidden-wrap">&nbsp;</div>
                      <div class="score-wrap">
                        <div>&nbsp;</div>
                        <div class="icon-wrap" style="visibility: hidden;">&nbsp;</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="stat-data">
                      <span>
                        Overall score
                      </span>
                    </div>
                  </th>
                  <th
                    v-for="(header, idx) in activeHeaders"
                    :key="idx"
                    class=""
                  >
                    <div class="stat-data">
                      <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{header}}</span>
                      </template>
                      <span class="text-capitalize">{{header}}</span>
                    </v-tooltip>
                      <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">{{header.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
                        </template>
                        <span class="text-capitalize">{{header.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</span>
                      </v-tooltip> -->
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="(row, driver) in tableData"
                >
                  <tr :key="`${driver}`" :class="driver === activeDriver ? 'activeDriver' : 'driver'">
                    <td class="am-table-row">
                    <div class="left-row d-flex justify-space-between">
                      <div class="score-wrap">
                        <div class="icon-wrap" @click="toggleDriver(driver)">
                          <i :ref="`${driver}-hide`" class="las la-angle-down" style="font-size: 16px !important;display:none;"></i>
                          <i :ref="`${driver}-show`" class="las la-angle-right" style="font-size: 16px !important;"></i>
                          <!-- <i class="las la-angle-down" style="font-size: 16px !important;display:none;"></i>
                          <i class="las la-angle-right" style="font-size: 16px !important;"></i> -->
                        </div>
                      <!-- </div>
                      <div class=""> -->
                        <div class="cursor-pointer">
                          <div class="subdriver-name" @click="viewDriver(driver)">{{driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</div>
                          <div class="analysis-sub text-left">It has {{Object.keys(tableData[driver].sub_drivers).length}} sub drivers</div>
                        </div>
                      </div>
                    </div>
                  </td>
                    <td class="score subdriver-data" :style="`background-color:${getColor(row.average)}`">
                      {{row.average}}
                    </td>
                    <td
                      v-for="(header, key) in activeHeaders"
                      :key="key"
                      :class="header"
                      class="subdriver-data cursor-pointer"
                      :style="`background-color:${getColor(getValue(driver, header))}`"
                    >
                      <span v-if="getValue(driver, header)" @click="viewDriverWithScore(driver, header)">{{getValue(driver, header).toFixed(1)}}</span>
                      <span v-else>--</span>
                    </td>
                  </tr>
                  <template
                    v-for="(sd, subdriver) in tableData[driver].sub_drivers">
                    <tr
                      :key="`${subdriver}-${driver}-subdriver`"
                      :ref="driver"
                      :class="driver === activeDriver ? 'activeSubDriver' : ''"
                      :id="subdriver"
                      style="display:none;"
                    >
                      <td class="am-table-row">
                        <div class="left-row d-flex justify-space-between">
                          <div class="score-wrap">
                            <div class="icon-wrap" @click="toggleSubDriver(subdriver)">
                              <i :ref="`${subdriver}-hide`" :class="`${driver}-subDriverHide`" class="las la-minus" style="font-size: 16px !important;display:none;"></i>
                              <i :ref="`${subdriver}-show`" :class="`${driver}-subDriverShow`" class="las la-plus" style="font-size: 16px !important;display:block;"></i>
                            </div>
                            <div>
                              <div class="subdriver-name" @click="viewSubDriver(driver, subdriver)">{{subdriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}</div>
                              <div class="analysis-sub">
                                It has {{Object.keys(tableData[driver].sub_drivers[subdriver].questions).length}} questions
                              </div>
                            </div>
                          </div>
                          <!-- <div>{{Object.keys(tableData[driver].sub_drivers[subdriver].questions).length}} Questions</div> -->
                        </div>
                      </td>
                      <td class="score subdriver-data" :style="`background-color:${getColor(sd.average)}`">
                        {{sd.average}}
                      </td>
                      <td
                        v-for="(header, key) in activeHeaders"
                        :key="key"
                        :class="header"
                        class="subdriver-data cursor-pointer"
                        :style="`background-color:${getColor(getSubDriverValue(driver, subdriver, header))}`"
                      >
                        <span v-if="getSubDriverValue(driver, subdriver, header)"
                          @click="viewSubDriverWithScore(driver, subdriver, header)"
                        >
                          {{getSubDriverValue(driver, subdriver, header).toFixed(1)}}
                        </span>
                        <span v-else>--</span>
                      </td>
                    </tr>
                    <!-- :key="`${subdriver}-${driver}-subdriver`" -->
                    <tr
                      v-for="(q, key) in tableData[driver].sub_drivers[subdriver].questions"
                      :key="`${driver}-${subdriver}-${key}-question`"
                      :ref="subdriver"
                      :id="key"
                      :class="driver === activeDriver ? `activeQuestion ${driver}` : ''"
                      style="display:none;"
                    >
                      <td class="am-table-row">
                        <div class="left-row">
                            <div class="score-wrap">
                              <div class="icon-wrap" @click="hide(driver)">
                                <i class="las la-dot-circle" style="font-size: 16px !important;"></i>
                              </div>
                            <div class="subdriver-question" @click="viewQuestion(driver, subdriver, key)">{{key}}</div>
                          </div>
                        </div>
                      </td>
                      <td
                        class="subdriver-data"
                        :style="`background-color:${getColor(row.average)}`"
                      >
                        {{q.average}}
                      </td>
                      <td
                        v-for="(header, idx) in activeHeaders"
                        :key="idx"
                        class="subdriver-data"
                        :style="`background-color:${getColor(getQuestionValue(driver, subdriver, key, header))}`"
                      >
                        <span v-if="getQuestionValue(driver, subdriver, key, header)"
                          @click="viewQuestionWithScore(driver, subdriver, key, header)"
                        >
                          {{getQuestionValue(driver, subdriver, key, header).toFixed(1)}}
                        </span>
                        <span v-else>--</span>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <v-row no-gutters class="pt-5 mt-5">
          <v-col cols="3"></v-col>
          <v-col cols="9">
            <div class="driver-heatmap-range">
              <v-row no-gutters>
                <v-col>
                  <span class="heat one">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat two">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat three">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat four">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat five">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat six">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat seven">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat eight">&nbsp;</span>
                </v-col>
                <v-col>
                  <span class="heat nine">&nbsp;</span>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters class="">
          <v-col cols="3"></v-col>
          <v-col cols="9">
            <div class="driver-heatmap-range">
              <v-row no-gutters>
                <v-col class="text-left">
                  <div>Disengaged</div>
                </v-col>
                <v-col class="text-center">
                  <div>Passively engaged</div>
                </v-col>
                <v-col class="text-right">
                  <div>Highly engaged</div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'phasesCard',

  components: {
    ContentLoader
  },

  props: {
    data: {
      required: true,
      type: Object,
      default: () => {}
    },
    initialLoading: {
      required: true,
      type: Boolean
    },
    showReport: {
      required: true,
      type: Boolean
    },
    allTableData: {
      type: [Object, Array]
    },
    tableData: {
      required: false,
      type: Object
    },
    sortByData: {
      required: true,
      type: [Object, Array]
    }
  },

  data () {
    return {
      activeSort: 'location',
      // sortByData: {
      //   location: 'Location',
      //   site: 'Site',
      //   department: 'Department',
      //   gender: 'Gender',
      //   business: 'Business',
      //   grade: 'Grade',
      //   hrbp: 'HR Business Partner',
      //   hr_manager: 'HR Manager',
      //   cluster: 'Cluster'
      // },
      activeHeaders: [],
      selectedHeaders: [],
      activeDriver: null,
      activeSubDriver: 'Collaboration',
      page: 0,
      limit: 6,
      totalData: null,
      endlimit: null,
      startlimit: null,
      lastActiveSubDriver: null,
      lastActiveQuestion: null
    };
  },

  mounted () {
    // this.getTableHeaders();
    // this.display(this.page);
  },

  watch: {
    selectedHeaders: {
      deep: true,
      handler () {
        if (this.selectedHeaders.length === 0) {
          this.activeHeaders = [];
        }
        if (this.selectedHeaders.length === this.allTableData.length) {
          this.display(this.page);
        }
        if (this.selectedHeaders.length <= this.limit) {
          this.compareCustom(this.page);
        }
      }
    },
    allTableData: {
      handler () {
        this.getTableHeaders();
        // this.getTableHeaders();
        this.display(this.page);
      }
    }
  },

  computed: {
    icon () {
      if (this.allOptionSelected) return 'lar la-window-close';
      if (this.someOptionSelected) return 'lar la-minus-square';
      return 'las la-stop';
    },
    allOptionSelected () {
      return this.selectedHeaders.length === this.allTableData.length;
    },
    someOptionSelected () {
      return this.selectedHeaders.length > 0 && !this.allOptionSelected;
    }
  },

  methods: {
    viewDriver (driver) {
      console.log(driver);
      console.log(this.data.id);
      if (this.data.id === 'initial') {
        this.data.id = 'initial_development';
      }
      const temp = {
        segment_filter: this.data.id
      };
      this.$router.push({
        path: '/drivers/view',
        query: {
          driver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewDriverWithScore (driver, stage) {
      let t = {};
      t[this.activeSort] = [];
      t[this.activeSort].push(stage);
      t = { ...t, ...this.updateReportFilters };
      const temp = {
        filters: t,
        segment_filter: this.data.id
      };
      this.$router.push({
        path: '/drivers/view',
        query: {
          driver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewSubDriver (driver, subdriver) {
      this.$router.push({
        path: '/drivers/view/subdriver',
        query: {
          driver,
          subdriver
        }
      }).catch(() => {});
    },
    viewSubDriverWithScore (driver, subdriver, stage) {
      let t = {};
      // t.segment_filter = this.data.id;
      t[this.activeSort] = [];
      t[this.activeSort].push(stage);
      t = { ...t, ...this.updateReportFilters };
      const temp = {
        filters: t,
        segment_filter: this.data.id
      };
      this.$router.push({
        path: '/drivers/view/subdriver',
        query: {
          driver,
          subdriver,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    viewQuestion (driver, subdriver, question) {
      this.$router.push({
        path: '/drivers/view/questions',
        query: {
          driver,
          subdriver,
          question
        }
      }).catch(() => {});
    },
    viewQuestionWithScore (driver, subdriver, question, stage) {
      let t = {};
      // t.segment_filter = this.data.id;
      t[this.activeSort] = [];
      t[this.activeSort].push(stage);
      t = { ...t, ...this.updateReportFilters };
      const temp = {
        filters: t,
        segment_filter: this.data.id
      };
      this.$router.push({
        path: '/drivers/view/questions',
        query: {
          driver,
          subdriver,
          question,
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
    },
    onView (id) {
      this.$emit('onViewReport', id);
    },
    onClickSortBy (val) {
      this.activeSort = val;
      this.$emit('onClickSortByDrivers', val);
      this.page = 0;
    },
    getTableHeaders () {
      if (this.allTableData) {
        this.selectedHeaders = this.allTableData;
        this.totalData = this.allTableData.length;
        // console.log(this.selectedHeaders);
      }
    },
    displayPre () {
      if (this.page <= 0) {
        return;
      }
      this.page = this.page - 1;
      this.display(this.page);
    },
    displayNext () {
      if (this.endlimit > this.totalData) {
        return;
      }
      this.page = this.page + 1;
      this.display(this.page);
    },
    display (page) {
      if (page < 0) {
        return;
      }
      const start = this.limit * page;
      const end = start + this.limit;
      this.startlimit = start;
      this.endlimit = end;
      this.selectedHeaders = this.allTableData;
      const tempData = this.selectedHeaders.slice(start, end);
      this.activeHeaders = tempData;
    },
    compareCustom (page) {
      if (page < 0) {
        return;
      }
      const start = this.limit * page;
      const end = start + this.limit;
      this.startlimit = start;
      this.endlimit = end;
      // this.selectedHeaders = this.allTableData;
      const tempData = this.selectedHeaders.slice(start, end);
      this.activeHeaders = tempData;
    },
    getValue (driver, header) {
      return this.tableData[driver].demographic_wise_avarage[header];
    },
    getSubDriverValue (driver, subDriver, header) {
      return this.tableData[driver].sub_drivers[subDriver].demographic_wise_avarage[header];
    },
    getQuestionValue (driver, subDriver, question, header) {
      if (this.tableData[driver] && this.tableData[driver].sub_drivers[subDriver] && this.tableData[driver].sub_drivers[subDriver].questions[question]) {
        return this.tableData[driver].sub_drivers[subDriver].questions[question].demographic_wise_avarage[header];
      }
    },
    toggleDriver (driver) {
      this.activeDriver = driver;
      const Drivers = Object.keys(this.tableData);
      const activeSubdrivers = Object.keys(this.tableData[driver].sub_drivers);
      this.lastActiveSubDriver = activeSubdrivers[activeSubdrivers.length - 1];
      const tempElement = document.getElementById(this.lastActiveSubDriver);
      tempElement.style.borderBottom = '2px solid rgba(0, 0, 0, 0.6)';
      // console.log('toggleDriver -> tempElement', tempElement.style);
      this.$lodash.each(Drivers, (val) => {
        if (val !== driver) {
          // reset subdrivers icons end
          this.$lodash.each(this.$refs[val], (value, key) => {
            // console.log('toggleDriver -> value, key', value, key);
            value.style.display = 'none';
          });
        }
        // reset driver icons start
        this.$refs[`${val}-show`][0].style.display = 'block';
        this.$refs[`${val}-hide`][0].style.display = 'none';
        // reset drivers icons end
        // disable questions start
        const tempQuestions = document.getElementsByClassName(val);
        this.$lodash.each(tempQuestions, (val) => {
          val.style.display = 'none';
        });
        // disable questions end
        // reset subdrivers icons start
        const subDriverShowIcon = document.getElementsByClassName(`${val}-subDriverShow`);
        const subDriverHideIcon = document.getElementsByClassName(`${val}-subDriverHide`);
        this.$lodash.each(subDriverShowIcon, (value) => {
          value.style.display = 'block';
        });
        this.$lodash.each(subDriverHideIcon, (value) => {
          value.style.display = 'none';
        });
      });
      if (this.$refs[driver][0].style.display === 'none') {
        this.$refs[`${driver}-show`][0].style.display = 'none';
        this.$refs[`${driver}-hide`][0].style.display = 'block';
        this.$lodash.each(this.$refs[driver], (val, key) => {
          val.style.display = 'table-row';
        });
      } else {
        this.$refs[`${driver}-show`][0].style.display = 'block';
        this.$refs[`${driver}-hide`][0].style.display = 'none';
        this.$lodash.each(this.$refs[driver], (val) => {
          val.style.display = 'none';
        });
        const tempQuestions = document.getElementsByClassName(driver);
        this.$lodash.each(tempQuestions, (val) => {
          val.style.display = 'none';
        });
        this.activeDriver = null;
      }
    },
    removeBorderOfSubDriver () {
      const tempElement = document.getElementById(this.lastActiveSubDriver);
      const icon = this.$refs[`${this.lastActiveSubDriver}-hide`][0].style.display;
      if (icon === 'none') {
        tempElement.style.borderBottom = '0';
      } else {
        tempElement.style.borderBottom = '2px solid rgba(0, 0, 0, 0.6)';
      }
    },
    toggleSubDriver (subDriver) {
      // const subDrivers = Object.keys(this.tableData[this.activeDriver].sub_drivers);
      // this.$lodash.each(subDrivers, (val) => {
      //   // console.log('toggleSubDriver -> val', val);
      //   if (val !== subDriver) {
      //     this.$lodash.each(this.$refs[val], (value) => {
      //       value.style.display = 'none';
      //     });
      //   }
      // });
      const activeQuestion = Object.keys(this.tableData[this.activeDriver].sub_drivers[this.lastActiveSubDriver].questions);
      this.lastActiveQuestion = activeQuestion[activeQuestion.length - 1];
      const tempElement = document.getElementById(this.lastActiveQuestion);
      tempElement.style.borderBottom = '2px solid rgba(0, 0, 0, 0.6)';
      if (subDriver === this.lastActiveSubDriver) {
        this.removeBorderOfSubDriver();
      }
      if (this.$refs[subDriver][0].style.display === 'none') {
        this.$refs[`${subDriver}-show`][0].style.display = 'none';
        this.$refs[`${subDriver}-hide`][0].style.display = 'block';
        this.$lodash.each(this.$refs[subDriver], (val) => {
          val.style.display = 'table-row';
        });
      } else {
        this.$refs[`${subDriver}-show`][0].style.display = 'block';
        this.$refs[`${subDriver}-hide`][0].style.display = 'none';
        this.$lodash.each(this.$refs[subDriver], (val) => {
          val.style.display = 'none';
        });
      }
    },
    getColor (val) {
      if (val) {
        let color = '#ffffff';
        const radixPos = String(val).indexOf('.');
        let value = String(val).slice(radixPos).split('.')[1];
        if (!value) {
          value = 0;
        }
        if (val > 0 && val <= 1) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 80})`;
        }
        if (val > 1 && val <= 2) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 60})`;
        }
        if (val > 2 && val <= 3) {
          color = `rgba(244, 67, 54, 0.${(10 - Number(value)) + 40})`;
        }
        if (val > 3 && val < 4) {
          color = `rgba(246, 251, 252, 0.${Number(value)})`;
        }
        if (val === 4) {
          color = 'rgba(246, 251, 252, 1)';
        }
        if (val > 4 && val < 5) {
          color = `rgba(100, 231, 100, 0.${(Number(value))})`;
        }
        if (val === 5) {
          color = 'rgba(100, 231, 100, 1)';
        }
        return color;
      }
      if (val === 0) {
        return 'rgba(244, 67, 54, 1)';
      }
    },
    toggle () {
      this.$nextTick(() => {
        if (this.allOptionSelected) {
          this.selectedHeaders = [];
          this.activeHeaders = [];
        } else {
          this.display(this.page);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-cards {
  padding: 0;
  // box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),
  //   0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
}
.analysis-cards {
  background-color: var(--bg);
}
.analysis-sub {
      font-size: var(--content-sub-size);
      color: var(--color-palceholder);
      padding: 0;
      text-align: left;
    }
.root-QkPFX {
  box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #e7e8e7;
    height: 100%;
    min-height: 230px;
    width: 100%;
    .container-OWvmz {
      display: flex;
      justify-content: space-between;
      height: inherit;
      .left-26Ldc {
          width: calc(100% - 326px);
          display: flex;
          padding: 20px;
          .iconContainer-2MeWz {
              margin: 0 20px 0 0;
              .icon-3NJqh {
                justify-content: center;
                display: flex;
                width: 64px;
                height: 64px;
                background-color: #fff;
                border: 1px solid rgba(0,0,0,.05);
                border-radius: 50%;
            }
          }
          .headline-30cHB {
              // font-size: 24px;
              font-size: var(--stats-size-1);
              color: var(--color-text);
              // color: #2c2f37;
          }
          .range-1KVMZ {
            color: var(--color-text);
            font-size: var(--content-size);
            margin: 5px 0 0;
          }
          .summary-3WdmL {
            margin: 20px 0;
            // font-size: 14px;
            // color: #4a4a4a;
            color: var(--color-palceholder);
            font-size: var(--content-sub-size);
          }
          .peak-btn.peak-btn-primary {
              background-color: var(--primary-color);
          }
          .peak-btn.peak-btn-small {
              font-size: 11px;
              line-height: 30px;
              min-width: 40px;
              padding: 0 1.6em;
          }
          .peak-btn {
              -webkit-appearance: none;
              border: 1px solid rgba(0,0,0,.03);
              border-radius: 2px;
              // box-shadow: 0 1px 2px 0 rgba(0,0,0,.11), inset 0 -1px 1px 0 rgba(0,0,0,.09);
              box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
              color: #fff;
              cursor: pointer;
              display: inline-block;
              margin: 0;
              overflow: visible;
              text-align: center;
              text-decoration: none;
              transition: all .2s ease;
              user-select: none;
              vertical-align: middle;
              white-space: nowrap;
          }
      }
      .right-3NnIh {
          width: 326px;
          border-left: 1px solid #e6e8eb;
          .rightTop-MkCrM {
              padding: 30px;
              height: 50%;
              border-bottom: 1px solid #e6e8eb;
              .rightHeader-1gKU_ {
                  display: flex;
                  .rightHeaderIcon-D4hI9 {
                      height: 24px;
                      width: 24px;
                      vertical-align: middle;
                      display: inline-block;
                      margin-left: -3px;
                  }
                  .rightHeaderText-3QAP5 {
                      // font-size: 11px;
                      font-size: var(--content-sub-size);
                      color: var(--color-placeholder);
                      // color: #9b9b9b;
                      // text-transform: uppercase;
                      margin: 4px;
                  }
              }
              .root-1ZrjO.small-1dQfH {
                  display: flex;
                  height: 38px;
                  .score-3eag5 {
                      color: #2c2f37;
                      display: flex;
                      flex-direction: column;
                      font-size: 27px;
                      font-weight: 600;
                      font-weight: 400;
                      justify-content: center;
                      line-height: 1;
                      font-size: var(--stats-size-1);
                      color: var(--color-text);
                      .static-24kmv {
                          height: auto;
                          width: auto;
                          font-size: 27px;
                      }
                  }
                  .container-A8OY- {
                      display: flex;
                      align-items: flex-end;
                      height: 100%;
                      margin-top: -5px;
                      .label-2HCys {
                          margin: 0 3px 0 5px;
                          font-size: 12px;
                          color: #050550;
                      }
                      .label-2_vVU, .toggler-2GB1U {
                          color: #29434b;
                          font-size: 12px;
                          display: inline-flex !important;
                          .badge-2Vbr1 {
                              margin-left: 3px;
                              .badge-LGq1o {
                                font-size: 11px;
                                background-color: rgba(252,198,88,.3);
                                color: #f79c00;
                                font-size: 9px;
                                min-width: 26px;
                                padding: 2px;
                                text-align: center;
                            }
                          }
                      }
                  }
              }
          }
          .rightBottom-1e9Jt {
              height: 50%;
              display: flex;
              justify-content: space-between;
              .rightBottomContainer-kSlaE {
                  width: 50%;
                  border-left: 1px solid #e6e8eb;
                  padding: 30px;
                  .rightHeader-1gKU_ {
                      display: flex;
                      .rightHeaderIcon-D4hI9 {
                          height: 24px;
                          width: 24px;
                          vertical-align: middle;
                          display: inline-block;
                          margin-left: -3px;
                      }
                      .rightHeaderText-3QAP5 {
                          font-size: 11px;
                          color: #9b9b9b;
                          // text-transform: uppercase;
                          margin: 4px;
                          font-size: var(--content-sub-size);
                          color: var(--color-placeholder);
                      }
                  }
                  .rightContent-1quOS {
                    text-align: left;
                    font-size: 20px;
                    font-size: var(--stats-size-1);
                    color: var(--color-text);
                }
              }
          }
      }
    }
}
.tableFixHead {
    position:relative;
    // overflow-x: auto;
    // background: #fbfcff !important;
    min-height: 50vh;
    .table-wrap {
      // width:100%;
    }
    .table-bordered {
      // width: 100%;
      margin: 0 !important;
    }
    table {
      border-collapse: collapse;
    }
    td {
      padding: 8px 16px;
    }
    th {
      padding: 8px;
      border: 1px solid rgba(0,0,0,0.1);
      background: #fff;
      .stat-data {
        text-transform: capitalize;
        width: 100px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-word;
        white-space: nowrap;
        padding: 0;
        text-align: center;
      }
    }
    tbody {
      tr {
        // border: 1px solid rgba(0,0,0,0.1);
        td {
          text-align: center;
        }
      }
      .driver {
        border: 1px solid rgba(0,0,0,0.1);
      }
    }
    td:first-child, th:first-child {
      // position:sticky;
      // left:0;
      // z-index:1;
      // background-color:transparent;
    }
    .am-table-head {
      // position: sticky;
      z-index: 0;
      justify-content: space-between;
      min-width: 350px;
      background: #ffffff !important;
      width: 100%;
      .left-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .score-wrap {
          display: flex;
          th {
            border: 0;
          }
          .icon-wrap {
            pointer-events: none;
          }
        }
      }
    }
    .am-table-row {
      display: flex;
      justify-content: space-between;
      min-width: 300px;
      background: #ffffff !important;
      border-bottom: 0;
      padding: 0 !important;
      border: 1px solid rgba(0,0,0,0.1);
      .left-row {
        display: flex;
        width: 100%;
        // padding: 8px 16px !important;
        padding: 16px !important;
        .left-wrap {
          padding: 8px 16px;
        }
        .score {
          padding: 8px 13px;
          border-left: 1px solid rgba(0, 0, 0, 0.05);
          width: 80px;
        }
        .score-wrap {
          display: flex;
          .icon-wrap {
            cursor: pointer;
            padding-right: 16px;
          }
        }
        .subdriver-name {
          text-transform: capitalize;
          font-weight: 600;
          text-align: left;
        }
        .subdriver-question {
          font-weight: 500;
          text-align: left;
        }
      }
    }
    .score {
      font-weight: 600;
    }
    .question-analysis {
      // display: none;
      .am-table-row {
        background-color: rgba(0,0,0,0.015) !important;
        box-shadow: unset;
        .left-row {
          cursor: pointer;
        }
      }
    }
    .subdriver-analysis {
      .am-table-row {
        background-color: rgba(0,0,0,0.025) !important;
        box-shadow: unset;
        .left-row {
          cursor: pointer;
        }
      }
    }
    .subdriver-data {
      background: #ffffff;
      border: 1px solid rgba(0,0,0,0.05);
      font-weight: 600;
    }
  }
  .driver-heatmap-range {
    .heat {
      height: 12px;
      text-align: center;
      display: block;
      border: 0.1px solid rgba(0,0,0,0.1);
      &.one {
        background-color: rgba(244, 67, 54, 1);
      }
      &.two {
        background-color: rgba(244, 67, 54, 0.8);
      }
      &.three {
        background-color: rgba(244, 67, 54, 0.4);
      }
      &.four {
        background-color: rgba(246, 251, 252, 0.6);
      }
      &.five {
        background-color: rgba(246, 251, 252, 0.8);
      }
      &.six {
        background-color: rgba(246, 251, 252, 1);
      }
      &.seven {
        background-color: rgba(100, 231, 100, 0.6);
      }
      &.eight {
        background-color: rgba(100, 231, 100, 0.8);
      }
      &.nine {
        background-color: rgba(100, 231, 100, 1);
      }
    }
  }
  .activeDriver {
    border: 2px solid rgba(0,0,0,0.6);
    border-bottom: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.1) !important;
    }
  }
  .activeSubDriver {
    border: 2px solid rgba(0,0,0,0.6);
    border-bottom: 0;
    border-top: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.06) !important;
    }
    // &.mystyle {
    //   border: 40px solid rgba(0,0,0,1) !important;
    // }
  }
  .activeQuestion {
    border: 2px solid rgba(0,0,0,0.6);
    border-bottom: 0;
    border-top: 0;
    .am-table-row {
      background-color: rgba(0, 0, 0, 0.02) !important;
    }
  }
  .top-nav {
      z-index: 0;
      position: relative;
      ul {
        // padding: 0px 50px !important;
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        padding: 0 25px;
        li {
          position: relative;
          .top-menu {
            height: 48px;
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
            display: flex;
            align-items: center;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            margin-right: 0.25rem;
            // color: var(--bg);
            font-size: var(--heading-size);
            position: relative;
            position: relative;
            .top-menu__title {
              display: flex;
              align-items: center;
              white-space: nowrap;
              cursor: pointer;
              font-size: var(--content-size);
            }
            &.top-menu--active {
              background-color: var(--bg-panel);
              animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
              animation-fill-mode: forwards;
              :before {
                content: "";
                width: 20px;
                height: 20px;
                margin-left: -20px;
                transform: rotate(90deg) scale(1.04);
                background-size: 100%;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
                position: absolute;
                bottom: 0;
                left: 0;
              }
              :after {
                content: "";
                width: 20px;
                height: 20px;
                margin-right: -20px;
                transform: rotate(180deg) scale(1.04);
                background-size: 100%;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
                position: absolute;
                bottom: 0;
                right: 0;
              }
              .top-menu__title {
                color: var(--color-headings);
                font-weight: var(--heading-weight);
                font-size: var(--content-size);
              }
            }
            &:not(.top-menu--active) {
              opacity: 0;
              // transform: translateY(50px);
              animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
              animation-fill-mode: forwards;
              animation-delay: 0.2s;
            }
          }
          @keyframes intro-active-menu-animation {
            100% {
              z-index: 10;
            }
          }
          @keyframes intro-menu-animation {
            100% {
              opacity: 1;
              // transform: translateX(0px);
            }
          }
        }
      }
    }
    .nav-body {
      background-color: var(--bg-panel);
      padding: 0px 10px;
    }
</style>
